import { classNames } from '../utils/UNSAFE_classNames';
import { mergeProps } from '../utils/UNSAFE_mergeProps';
import { useActive } from '../hooks/UNSAFE_useActive';
import { useTestId, TestIdProps } from '../hooks/UNSAFE_useTestId';
import { DragV } from '../UNSAFE_RedwoodIcons/DragV';
import { iconStyle, hoverStyle, activeStyle } from './themes/DragHandleStyles.css';

type Props = TestIdProps;

/**
 * A draggable icon that shows grab cursor when users hover the mouse on it,
 * and shows grabbing cursor when users click the icon.
 */
export function DragHandle({ testId }: Props) {
  const { isActive, activeProps } = useActive();
  const testIdProps = useTestId(testId);
  const classes = classNames([iconStyle, isActive ? activeStyle : hoverStyle]);
  return (
    <div
      {...mergeProps(activeProps, testIdProps)}
      draggable={true}
      class={classes}
      role="presentation">
      <DragV />
    </div>
  );
}
